import { render, staticRenderFns } from "./PregledReferentnihPerioda.vue?vue&type=template&id=5d2306bd&scoped=true&"
import script from "./PregledReferentnihPerioda.vue?vue&type=script&lang=ts&"
export * from "./PregledReferentnihPerioda.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2306bd",
  null
  
)

export default component.exports